import moment from 'moment';

window.Parsley.addValidator('thirtyFiveDaysInFuture', {
  requirementType: 'string',
  validateString(value) {
    const date = moment(value);
    const thirtyFiveDaysFromNow = moment().add(35, 'days');
    return date.isSameOrAfter(thirtyFiveDaysFromNow, 'day');
  },
  messages: {
    en: 'The date must be 35 or more days from now. '
  }
});
